<template>
  <div class="auth-wrapper auth-v2">
    <div class="vx-row auth-inner m-0">
      <!-- Brand logo-->
      <div class="brand-logo d-none lg:flex">
        <img
          src="@/assets/images/project/hexasense-logo.png"
          alt="logo"
          width="200px"
          height="100%"
        />
      </div>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <div
        class="vx-col w-full lg:w-7/12 xl:w-2/3 d-none lg:flex items-center p-5"
      >
        <div class="w-full lg:flex items-center justify-center px-5">
          <img :src="imgUrl" width="70%" height="70%" alt="Login" />
        </div>
      </div>
      <!-- /Left Text-->

      <div
        class="vx-col w-full lg:w-5/12 xl:w-1/3 flex items-center auth-bg p-5"
      >
        <div
          class="
            vx-col
            w-full
            sm:w-3/4
            md:w-7/12
            lg:w-full
            xl:w-full
            mx-auto
            mobil-vx-card
            p-10
          "
        >
          <div class="mb-5 brand-logo-v2">
            <img
              src="@/assets/images/project/hexasense-logo.png"
              alt="logo"
              width="200px"
              height="100%"
            />
          </div>
          <div class="h4 mb-2">{{ $t("login.ForgotPassword") }}</div>
          <div class="mb-2">{{ $t("login.ForgotPasswordMessage") }}</div>

          <form action="" class="mt-6">
            <div class="mb-4">
              <label class="vs-input--label" for="email_field"
                >{{ $t("login.FormMail") }}:</label
              >
              <div
                class="
                  vs-component vs-con-input-label vs-input
                  w-full
                  vs-input-warning
                "
              >
                <div class="vs-con-input">
                  <input
                    v-validate="'required|email'"
                    name="email_field"
                    type="email"
                    :placeholder="$t('login.FormMail')"
                    v-model="email"
                    v-on:keyup.enter="queryForKeywords"
                    class="vs-inputx vs-input--input normal"
                    style="border: 1px solid rgba(0, 0, 0, 0.2)"
                  />
                </div>
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('email_field')"
              >
                <span v-if="email == ''">
                  {{ $t("login.FormMailEmpty") }}
                </span>
                <span v-else>
                  {{ $t("login.FormMailValid") }}
                </span>
              </span>
            </div>

            <div class="vs-row mt-5">
              <invisible-recaptcha
                ref="clickButton"
                :sitekey="sitekey"
                :callback="forgotPasswordUserJWt"
                class="invisible-recaptcha-btn w-full"
              >
                <vs-button color="warning" class="w-full">
                  <span class="font-medium text-lg text-white">{{
                    $t("login.SavePassword")
                  }}</span><feather-icon
                  class="ml-3 bx-spin"
                  :class="isForgotPasswordLoading == true ? '' : 'd-none'"
                  icon="LoaderIcon"
                  svgClasses="w-5 h-5"
                ></feather-icon
              >
                </vs-button>
              </invisible-recaptcha>
            </div>
            <div
              class="w-full text-center flex items-center justify-center mt-4"
            >
              <feather-icon
                icon="ChevronLeftIcon"
                svgClasses="w-4 h-5"
                class="text-warning mr-2"
              /><router-link to="/login" class="text-warning">{{
                $t("login.BackToLogin")
              }}</router-link>
            </div>
            <div>
              <auth-footer />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '../../i18n/i18n.js'
import Footer from './components/footer.vue'
import InvisibleRecaptcha from 'vue-invisible-recaptcha'

export default {
  components: {
    'auth-footer': Footer,
    'invisible-recaptcha': InvisibleRecaptcha
  },
  data () {
    return {
      email: '',
      sitekey: process.env.VUE_APP_SITE_KEY,
      isForgotPasswordLoading:false,
      imgUrl: require('@/assets/images/pages/forgot-password1.png')
    }
  },
  methods: {
    queryForKeywords () {
      this.$refs.clickButton.click()
    },
    forgotPasswordUserJWt () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isForgotPasswordLoading = true
          this.$store
            .dispatch('recoverPassword', this.email)
            .then(() => {
              this.isForgotPasswordLoading = false
              this.$vs.dialog({
                color: 'success',
                title: i18n.t('notifyAlert.success.title'),
                text: i18n.t('messagebox.2001')
              })
              this.$router.push('/login')
            })
            .catch((error) => {
              this.isForgotPasswordLoading = false
              this.errorMsg(error)
            })
        }
      })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/pages/page-auth.scss";
</style>
